import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import {
  deleteServiceCallType,
  getServiceCallTypeOptions,
  storeServiceCallType,
} from '../api/services';

export const SERVICE_CALL_TYPE_OPTIONS_QUERY_KEY = [
  'typeServiceCallOptions',
];

const useTypeOptions = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const handleError = (error) => {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';
    enqueueSnackbar(message, { variant: 'error' });
  };

  const typeOptionsForServiceCall = useQuery(
    SERVICE_CALL_TYPE_OPTIONS_QUERY_KEY,
    getServiceCallTypeOptions,
    {
      retry: false,
      refetchOnWindowFocus: false,
      onError: handleError,
    },
  );

  const invalidateTypes = () =>
    queryClient.invalidateQueries({
      queryKey: SERVICE_CALL_TYPE_OPTIONS_QUERY_KEY,
    });

  const storeType = useMutation({
    mutationFn: storeServiceCallType,
    onError: handleError,
    onSuccess: invalidateTypes,
  });

  const deleteType = useMutation({
    mutationFn: deleteServiceCallType,
    onError: handleError,
    onSuccess: invalidateTypes,
  });

  return {
    deleteType,
    storeType,
    typeOptionsForServiceCall,
  };
};

export default useTypeOptions;
